import { render, staticRenderFns } from "./SkillEffectCard.vue?vue&type=template&id=137b65d4&scoped=true&"
import script from "./SkillEffectCard.vue?vue&type=script&lang=ts&"
export * from "./SkillEffectCard.vue?vue&type=script&lang=ts&"
import style0 from "./SkillEffectCard.vue?vue&type=style&index=0&id=137b65d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b65d4",
  null
  
)

export default component.exports